module.exports = __webpack_public_path__ + "7d685e960c2baa964b3be9a893eddd12.ttf";